import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/test.environment';

@Injectable({ providedIn: 'root' })
export class ErrorLoggerService {
  constructor(private http: HttpClient) {}

  logError(error: any): void {
    const payload = {
      errorMessage: error?.message || String(error),
      stack: error?.stack || null,
      url: typeof window !== 'undefined' ? window.location.pathname : ''
    };

    this.http.post(`${environment.apiBaseUrl}/api/errors/log`, payload)
      .subscribe({ error: () => {} }); // fire-and-forget
  }
}
